// no itx for this file
import Signal from "../models/Signal";
import Channel from "../models/Channel";
import BaseModel from "../models/BaseModel";
import GroupAddress from "../models/GroupAdress";
import BaseModelMap from "../models/BaseModelMap";
import Logger from "../Logger";
import { determineSignalType } from "../KnxProductDataTools/determineActorComObjectFunction";
import { actorActions } from "../KnxMappings/Actor/Actions";
import { actorStatus } from "../KnxMappings/Actor/Status";
import { buttonActions } from "../KnxMappings/Button/Actions";
import { buttonStatus } from "../KnxMappings/Button/Status";
import { isDevelopmentEnvironment } from "../estada-config";
import { findInMap } from "../models/utils";

const logger = new Logger();

export default class AddressGeneratorUtils {
  static getChannelTag(type: any) {
    if (type == "Switch") return "S";
    else if (type == "Dimmer") return "D";
    else if (type == "Heating") return "H";
    else if (type == "TuneableWhite") return "TW";
    else if (type == "Blind") return "R";
    else if (type == "Jalousie") return "J";
    else if (type == "Taster")
      return "T"; // Button
    else if (type == "Multiplexer")
      return "M"; // Button
    else return "O"; //Overflow
  }

  static getAddressForChannelTypeLevel2(type: any): number {
    if (type == "Switch") return 0;
    else if (type == "Dimmer") return 1;
    else if (type == "Heating") return 2;
    else if (type == "TuneableWhite") return 3;
    else if (type == "Lock") return 4;
    else if (type == "Blind") return 5;
    else if (type == "Jalousie") return 6;
    else if (type == "Multiplexer") return 7;
    else return 4; // 4 is also for Unkown / Rest
    // 7 is reserved
  }

  static getAddressForChannelTypeLevel1(type: any): number {
    if (type == "Tasten") return 7;
    return this.getAddressForChannelTypeLevel2(type);
  }

  static getOrCreateGroupAddressByAddress(params: {
    parent: BaseModel;
    level: number;
    tag: string;
    name: string;
    address: string;
  }): GroupAddress {
    const { parent, level, name, address, tag } = params;

    const x = parent.className == "GroupAddress" ? (parent as GroupAddress).children : parent;

    const parentCollection = x as BaseModelMap<GroupAddress>;

    //
    // look in current collection
    //
    var ga = getGaFromCollection(parentCollection, (a) => a.address == address);

    //
    // if still not found create a new GroupAddress
    //

    if (ga == undefined) {
      ga = new GroupAddress(
        {
          level: level,
          name: name,
          tag: tag,
          address: address,
        },
        parent,
      );
    } else {
      ga.tag = tag;
      ga.name = name;
    }

    parentCollection.addWithoutUpdate(ga);

    return ga;
  }

  static getOrCreateAddressByName(params: {
    parent: GroupAddress | BaseModelMap<GroupAddress>;
    level: number;
    tag: string;
    name: string;
    address: string;
  }): GroupAddress {
    const { parent, level, name, address, tag } = params;

    const x = parent.className == "GroupAddress" ? (parent as GroupAddress).children : parent;

    const parentCollection = x as BaseModelMap<GroupAddress>;

    var ga = getGaFromCollection(parentCollection, (a) => a.name == name);
    if (ga == undefined) {
      ga = GroupAddress.createNewGroupAddress({
        level: level,
        name: name,
        tag: tag,
        parent: parent,
      });
    }

    return ga;
  }

  static getConsumerChannelSignals(consumer: any): Array<Signal> {
    const consumerChannel = consumer.getConnectedChannel();
    if (consumerChannel) {
      const knxChannel = consumerChannel.mappedChannel;
      if (knxChannel) {
        return knxChannel.signals.sortBy("number");
      }
    }
    return [];
  }

  //
  // returns true if a new GroupAddress has been assigned
  // return false if address is allready assigned
  //

  static attachGroupAddressToSignal(knxSignal: Signal, adress: GroupAddress) {
    const knxChannel: Channel = knxSignal.parent as Channel;
    knxChannel.assetIsKnxChannel();

    var requestChannel = knxChannel.requestChannel;
    if (requestChannel == undefined) {
      logger.error(`no requestChannel for signal: ${knxSignal.number} ${knxSignal.name}`);
      return false;
    }

    var copyOfSignal = requestChannel?.getSignalByNumber(knxSignal.number);

    let ignoreChanged = false;
    if (!copyOfSignal) {
      copyOfSignal = new Signal({}, requestChannel);
      requestChannel.signals.addWithoutUpdate(copyOfSignal);
      ignoreChanged = true; // raiseOnChange will be fired later, because the signal is new
    } else {
      if (
        (knxChannel.isActorChannel && copyOfSignal.type.isStatus) ||
        (!knxChannel.isActorChannel && !copyOfSignal.type.isStatus)
      ) {
        //
        // check if the buttonSignal allready has a (manual) GroupAddress
        // if so, we cant create / add a new one,
        // because only 1 GA for Actions are valid
        //
        if (copyOfSignal.groupAddresses.length > 0) {
          return;
        }
      }
    }

    logger.log(
      `Copy signal for: ${knxSignal.tag} ${knxSignal.name} (${knxSignal.number}) - ${adress.fullAddress}  => ${copyOfSignal.id}`,
    );
    (copyOfSignal as any).mwe = "mwe1";

    function assignIfDifferent(field: string) {
      if (copyOfSignal) {
        if ((copyOfSignal as any)[field] != knxSignal[field]) {
          // console.log(`changed ${knxSignal.number} ${field}:`, copyOfSignal, (copyOfSignal as any)[field], knxSignal[field]);

          (copyOfSignal as any)[field] = knxSignal[field];
          if (!ignoreChanged) {
            // copyOfSignal.raiseOnChange(field);
          }
        }
      }
    }

    assignIfDifferent("tag");
    assignIfDifferent("_name");
    assignIfDifferent("instanceId");
    assignIfDifferent("type");
    assignIfDifferent("number");
    assignIfDifferent("knxId");
    assignIfDifferent("knxFunctionText");
    assignIfDifferent("knxDatapointType");

    copyOfSignal.addGroupAddress(adress);
    adress.addSignalBackpointer(copyOfSignal);

    var type;
    if (knxSignal.knxDatapointType == "") {
      logger.error("knxDatapointType missing");
      try {
        if (knxSignal.type.isActorSignal) {
          if (knxSignal.type.isStatus) {
            type = determineSignalType(knxSignal, actorStatus, undefined);
          } else {
            type = determineSignalType(knxSignal, actorActions, undefined);
          }
        } else {
          if (knxSignal.type.isStatus) {
            type = determineSignalType(knxSignal, buttonStatus, undefined);
          } else {
            type = determineSignalType(knxSignal, buttonActions, undefined);
          }
        }
      } catch (ex) {
        logger.error("determineSignalType", ex);
      }
      console.log(type);
    }

    const dpt = knxSignal.knxDatapointType.split("DPST-");
    adress.dpt = dpt && dpt.length > 1 ? dpt[1] : knxSignal.knxDatapointType;
  }
}

function getGaFromLastItems(
  parentCollection: BaseModelMap<GroupAddress>,
  filter: (item: GroupAddress) => boolean,
): GroupAddress | undefined {
  if (parentCollection.lastItems) {
    const ga = findInMap(parentCollection.lastItems, filter);
    if (ga) {
      parentCollection.addWithoutUpdate(ga);
      return ga;
    }
  }

  return undefined;
}

export function getGaFromCollection(
  parentCollection: BaseModelMap<GroupAddress>,
  filter: (item: GroupAddress) => boolean,
): GroupAddress | undefined {
  return parentCollection.findFirst(filter) || getGaFromLastItems(parentCollection, filter);
}
